import { SET_LANGUAGE, SET_LANGUAGE_LIST } from "../actionTypes";

const translationReducer = (
  state = { languageCode: "en-us", languageList: ["en-us"] },
  action
) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        languageCode: action.payload,
      };
    case SET_LANGUAGE_LIST:
      return {
        ...state,
        languageList: action.payload,
      };
    default:
      return state;
  }
};

export default translationReducer;
